import { gql } from '@moonpig/web-core-graphql'

export const GetUpcomingMissionButtonRemindersGQL = gql`
  query GetUpcomingMissionButtonReminders(
    $remindersRequest: GetRemindersInput!
    $isAuthenticated: Boolean!
  ) {
    reminders(input: $remindersRequest) @include(if: $isAuthenticated) {
      id
      name
      nextDate
      occasion
    }
  }
`
